import React from 'react'
import { useNavigate } from 'react-router-dom'
import './style.css'
const ExapandedMenu = ({ menu, name }) => {
    const navigate=useNavigate()
  return (
    <div >
        <p onClick={()=>navigate('/services/iso-certification')} className="text-primary mb-2 mt-2 ">Iso Certification</p>
        <p onClick={()=>navigate('/services/management-consultant')} className="text-primary mb-4 mt-4">Training</p>
        <p onClick={()=>navigate('/services/erp-program-provider')} className="text-primary mb-2">ERP Program Provider</p>
    </div>
  )
}

export default ExapandedMenu